module.exports = __webpack_public_path__ + "d0d56092a9d3519a882d2a36d1aac4a4.fbx";